import {Component, effect, signal} from '@angular/core';
import {ToastProviderService} from '../../provider-services/toast.provider-service';
import {ToastMessageTypeEnum} from '../../../typings/enums/toast-message-type.enum';
import {ToastModel} from '../../../typings/models/toast.model';

@Component({
  selector: 'app-toast',
  imports: [],
  templateUrl: './toast.component.html',
  styleUrl: './toast.component.scss'
})
export class ToastComponent {
  constructor(public toastProviderService: ToastProviderService) {
    effect(() => {
      this.toastProviderService.toasts$.subscribe((list) => this.toasts.set(list));
    });
  }

  toasts = signal<ToastModel[]>([]);
  ToastType = ToastMessageTypeEnum;

  dismiss(id: number) {
    this.toastProviderService.dismiss(id);
  }
}
